import {
	Grid,
	TextField,
	MenuItem,
	FormControl,
	FormControlLabel,
	Checkbox,
	Typography,
	Autocomplete,
	Alert,
	InputAdornment,
	Tooltip,
	Box,
	createFilterOptions
} from '@mui/material';
import FAIcon from '../FAIcon';
import FileInput from '../FileInput';
import FilePreview from '../FilePreview';
import parse from 'html-react-parser';
import { useState } from 'react';
//import * as Icons from '@material-ui/icons';
import * as Icons from '@mui/icons-material'; 

import _ from 'lodash';
//import { red } from '@mui/material/colors';

function FormRenderer({ partData = {}, parts, showValues = false, onChange, removeFile, errorElements, userData, lang = 'de' }) {
	const maxFileSize = 16000000; // 16mB
	const [showError, setShowError] = useState(false);

	// ToolTipTexte eintragen in den State
	const allToolTips = {};
	parts[partData.part]['external'].forEach(el => {
		const element = {
			...el,
			...(partData?.config || {}),
			...(partData?.config?.external || {}),
			...(_.isObject(partData?.config?.[el.id]) ? partData.config[el.id] : {}),
			...(_.isObject(partData?.config?.[el.id]?.external) ? partData.config[el.id].external : {}),
			...(_.isObject(partData?.config?.[el.id]?.config) ? partData.config[el.id].config : {}),
			...(_.isObject(partData?.config?.[el.id]?.config?.external) ? partData.config[el.id].config.external : {})
		};
		allToolTips[partData.id] = element.tip || '';
	});
	const [tooltipText, setTooltipText] = useState(allToolTips);
	const iconColor = '#777';

	return (
		<>
			{parts[partData.part]['external'].map(el => {
				const element = {
					...el,
					...(partData?.config || {}),
					...(partData?.config?.external || {}),
					...(_.isObject(partData?.config?.[el.id]) ? partData.config[el.id] : {}),
					...(_.isObject(partData?.config?.[el.id]?.external) ? partData.config[el.id].external : {}),
					...(_.isObject(partData?.config?.[el.id]?.config) ? partData.config[el.id].config : {}),
					...(_.isObject(partData?.config?.[el.id]?.config?.external) ? partData.config[el.id].config.external : {})
				};

				// Externe Ansicht deaktiviert für das Element?
				if (element?.display === false) return <></>; // Die Einträge unter Config und Extern werden ja schon in Element kopiert oben! Die anderen Einträge sind eigendlich überflüssig
				if (element?.['external']?.display === false) return <></>; // Prüfen direkt eintrag in external
				if (element?.['external']?.[partData?.id]?.display === false) return <></>; // Part in config (z.B. external.checkBerechtigt)
				if (element?.['external']?.[partData?.id]?.config?.display === false) return <></>; // Part in config (z.B. external.checkBerechtigt)
				if (userData?.[partData.id]?.display === false) return <></>;

				// LabelText
				const labelText =
					element?.config?.required || element?.required
						? (element.label?.[lang] || 'undefined') + '*'
						: element.label?.[lang] || 'undefined';

				// maxLength
				const maxLength = element?.config?.maxLength ? element.config.maxLength : element?.maxLength ? element?.maxLength : undefined;

				// Wenn das Icon nicht vorhanden ist dann das Icon nicht anzeigen
				if (!Icons[element?.icon]) element.icon = null;
				const StateElement = Icons[element?.icon];
				switch (element['domElement']) {
					case 'textInput':
						return (
							<Grid
								key={partData.id + '_' + element.id}
								item
								lg={element.grid.lg}
								md={element.grid.md}
								sm={element.grid.sm}
								xs={element.grid.xs}
							>
								<TextField
									InputLabelProps={{ className: 'meldooTextInputLabel' }}
									InputProps={{
										className: 'meldooTextInput',
										startAdornment: element?.icon ? (
											<InputAdornment position="start">
												<StateElement />
											</InputAdornment>
										) : null
									}}
									sx={element.tip ? { width: 'calc(100% - 40px)', float: 'left' } : { width: '100%' }}
									autoComplete={element.autocomplete || null}
									label={labelText}
									value={userData?.[partData.id]?.[element.id] || ''}
									onChange={e => onChange(e.target.value, partData.id, element.id, partData?.config, element?.config)}
									error={errorElements[partData.id]?.[element.id]}
									size="small"
									inputProps={{ maxLength: maxLength }}
								/>
								{element.tip && (
									<Box sx={{ marginLeft: '4px', width: '35px', float: 'right' }}>
										<Tooltip title={element.tip || ''} arrow color={'info'}>
											<Icons.Info style={{ color: iconColor }} />
										</Tooltip>
									</Box>
								)}
							</Grid>
						);
					case 'dateInput':
						return (
							<Grid
								key={partData.id + '_' + element.id}
								item
								lg={element.grid.lg}
								md={element.grid.md}
								sm={element.grid.sm}
								xs={element.grid.xs}
							>
								<TextField
									InputLabelProps={{ className: 'meldooTextInputLabel', shrink: true }}
									InputProps={{
										className: 'meldooTextInput',
										startAdornment: element?.icon ? (
											<InputAdornment position="start">
												<StateElement />
											</InputAdornment>
										) : null
									}}
									type="date"
									sx={element.tip ? { width: 'calc(100% - 40px)', float: 'left' } : { width: '100%' }}
									autoComplete={element.autocomplete || null}
									label={labelText}
									value={userData?.[partData.id]?.[element.id] || ''}
									onChange={e => onChange(e.target.value, partData.id, element.id, partData?.config, element?.config)}
									error={errorElements[partData.id]?.[element.id]}
									size="small"
									inputProps={{ maxLength: maxLength }}
								/>
								{element.tip && (
									<Box sx={{ marginLeft: '4px', width: '35px', float: 'right' }}>
										<Tooltip title={element.tip || ''} arrow color={'info'}>
											<Icons.Info style={{ color: iconColor }} />
										</Tooltip>
									</Box>
								)}
							</Grid>
						);
					case 'textareaInput':
						return (
							<Grid
								key={partData.id + '_' + element.id}
								item
								lg={element.grid.lg}
								md={element.grid.md}
								sm={element.grid.sm}
								xs={element.grid.xs}
							>
								<TextField
									InputLabelProps={{ className: 'meldooTextareaLabel' }}
									InputProps={{
										className: 'meldooTextareaInput',
										startAdornment: element?.icon ? (
											<InputAdornment position="start">
												<StateElement />
											</InputAdornment>
										) : null
									}}
									sx={element.tip ? { width: 'calc(100% - 40px)', float: 'left' } : { width: '100%' }}
									autoComplete={element.autocomplete || null}
									multiline
									minRows={4}
									label={labelText}
									value={userData?.[partData.id]?.[element.id] || ''}
									onChange={e => onChange(e.target.value, partData.id, element.id, partData?.config, element?.config)}
									error={errorElements[partData.id]?.[element.id]}
									size="small"
									inputProps={{ maxLength: maxLength }}
								/>
								{element.tip && (
									<Box sx={{ marginLeft: '4px', width: '35px', float: 'right' }}>
										<Tooltip title={element.tip || ''} arrow color={'info'}>
											<Icons.Info style={{ color: iconColor }} />
										</Tooltip>
									</Box>
								)}
							</Grid>
						);
					case 'checkBoxInput':
						return (
							<Grid
								key={partData.id + '_' + element.id}
								item
								lg={element.grid.lg}
								md={element.grid.md}
								sm={element.grid.sm}
								xs={element.grid.xs}
							>
								<FormControl error={errorElements[partData.id]?.[element.id]}>
									<FormControlLabel
										control={
											<Checkbox
												defaultChecked={userData?.[partData.id]?.[element.id] === true ? true : false}
												checked={userData?.[partData.id]?.[element.id] === true ? true : false}
												onChange={e => onChange(e.target.checked, partData.id, element.id, partData?.config, element?.config)}
											/>
										}
										label={<Typography className="meldooCheckBoxLabel">{parse(labelText)}</Typography>}
									/>
								</FormControl>
							</Grid>
						);
					case 'hiddenInput':
						return (
							<input
								key={partData.id + '_' + element.id}
								label={labelText}
								id={partData.id}
								value={userData?.[partData.id]?.[element.id] || ''}
								onChange={e => onChange(e.target.value, partData.id, element.id, partData?.config, element?.config)}
								error={errorElements[partData.id]?.[element.id]}
								InputProps={{ maxLength: maxLength }}
								hidden
							/>
						);
					case 'textBlock':
						return (
							<Grid
								className={'meldooTextBlock'}
								key={partData.id + '_' + element.id}
								item
								lg={element.grid.lg}
								md={element.grid.md}
								sm={element.grid.sm}
								xs={element.grid.xs}
							>
								{parse(partData?.config?.text || '')}
							</Grid>
						);
					case 'headerBlock':
						return (
							<Grid
								className={'meldooHeaderBlock'}
								id={partData.id}
								key={partData.id + '_' + element.id}
								item
								lg={element.grid.lg}
								md={element.grid.md}
								sm={element.grid.sm}
								xs={element.grid.xs}
							>
								{partData?.config?.text || ''}
							</Grid>
						);
					case 'seperatorBlock':
						return (
							<Grid
								className={'meldooSeperatorBlock'}
								key={partData.id + '_' + element.id}
								id={partData.id}
								item
								lg={12}
								md={12}
								sm={12}
								xs={12}
							>
								<hr />
							</Grid>
						);

					case 'emailInput':
						return (
							<Grid
								key={partData.id + '_' + element.id}
								item
								lg={element.grid.lg}
								md={element.grid.md}
								sm={element.grid.sm}
								xs={element.grid.xs}
							>
								<TextField
									InputLabelProps={{ className: 'meldooEmailInputLabel' }}
									InputProps={{
										className: 'meldooEmailInput',
										startAdornment: element?.icon ? (
											<InputAdornment position="start">
												<StateElement />
											</InputAdornment>
										) : null
									}}
									sx={element.tip ? { width: 'calc(100% - 40px)', float: 'left' } : { width: '100%' }}
									autoComplete={element.autocomplete || null}
									label={labelText}
									value={userData?.[partData.id]?.[element.id] || ''}
									onChange={e => onChange(e.target.value, partData.id, element.id, partData?.config, element?.config)}
									error={errorElements[partData.id]?.[element.id]}
									size="small"
									inputProps={{ maxLength: maxLength }}
								/>
								{element.tip && (
									<Box sx={{ marginLeft: '4px', width: '35px', float: 'right' }}>
										<Tooltip title={element.tip || ''} arrow color={'info'}>
											<Icons.Info style={{ color: iconColor }} />
										</Tooltip>
									</Box>
								)}
							</Grid>
						);
					case 'selectInput':
						return (
							<Grid
								key={partData.id + '_' + element.id}
								item
								lg={element.grid.lg}
								md={element.grid.md}
								sm={element.grid.sm}
								xs={element.grid.xs}
							>
								<TextField
									InputLabelProps={{ className: 'meldooSelectInputLabel' }}
									InputProps={{ className: 'meldooSelectInput' }}
									sx={element.tip ? { width: 'calc(100% - 40px)', float: 'left' } : { width: '100%' }}
									label={labelText}
									select
									value={userData?.[partData.id]?.[element.id] || ''}
									onChange={function (e) {
										setTooltipText(prev => ({
											...prev,
											[partData.id]:
												element['options']?.find(event => event.value === e.target.value)?.tip || element?.tip || ''
										}));
										onChange(e.target.value, partData.id, element.id, partData?.config, element?.config);
									}}
									error={errorElements[partData.id]?.[element.id]}
									size="small"
								>
									{element.options.map(option => (
										<MenuItem key={option.value} value={option.value}>
											{option.label}
										</MenuItem>
									))}
								</TextField>
								{element.tip && (
									<Box sx={{ marginLeft: '4px', width: '35px', float: 'right' }}>
										<Tooltip title={tooltipText?.[partData.id]} arrow color="info">
											<Icons.Info style={{ color: iconColor }} />
										</Tooltip>
									</Box>
								)}
							</Grid>
						);
					case 'autoSelectInput':
						const filterOptions = createFilterOptions({
							matchFrom: partData.config?.matchFrom ?? 'any'
						});
						return (
							<Grid
								key={partData.id + '_' + element.id}
								item
								lg={element.grid.lg}
								md={element.grid.md}
								sm={element.grid.sm}
								xs={element.grid.xs}
							>
								<Autocomplete
									autoComplete
									autoSelect
									autoHighlight
									sx={element.tip ? { width: 'calc(100% - 40px)', float: 'left' } : { width: '100%' }}
									value={userData?.[partData.id]?.[element.id] || ''}
									onChange={function (e, newValue) {
										setTooltipText(prev => ({
											...prev,
											[partData.id]:
												element['options']?.find(event => event.value === newValue?.value)?.tip || element?.tip || ''
										}));
										onChange(newValue?.value, partData.id, element.id, partData?.config, element?.config);
									}}
									size="small"
									renderInput={params => (
										<TextField
											{...params}
											InputProps={{ ...params.InputProps, className: 'meldooAutoSelectInput' }}
											InputLabelProps={{ className: 'meldooAutoSelectInputLabel' }}
											error={errorElements[partData.id]?.[element.id]}
											label={labelText}
										/>
									)}
									options={element.options}
									filterOptions={filterOptions}
								/>
								{element.tip && (
									<Box sx={{ marginLeft: '4px', width: '35px', float: 'right' }}>
										<Tooltip title={tooltipText?.[partData.id]} arrow color={'info'}>
											<Icons.Info style={{ color: iconColor }} />
										</Tooltip>
									</Box>
								)}
							</Grid>
						);
					case 'filesInput': {
						const checkFileSize = files => {
							// Hier könnte man noch eine Prüfung der maximalen Dateigröße vornehmen
							let sizeInLimit = true;
							files?.forEach(file => {
								if (file?.size > maxFileSize) {
									sizeInLimit = false;
									setShowError(true);
								}
							});
							if (sizeInLimit) setShowError(false);
							return sizeInLimit;
						};

						const maxFilesLimit = userData?.[partData.id]?.[element.id]?.length >= maxLength;
						const acceptedTypes = element?.acceptedTypes || '';

						return (
							<>
								{showError && (
									<Grid xs={12} item key={'int_' + partData.id + '_' + element.id + '_error'}>
										<Alert
											sx={{ marginBottom: '10px' }}
											//  className="mb-10"
											severity="error"
										>
											Fehler: Die Datei die Sie hochladen wollen ist zu groß. Die maximale Dateigröße beträgt{' '}
											{maxFileSize / 1000000} MiB
										</Alert>
									</Grid>
								)}
								<Grid
									className="meldoofilesInputLabel"
									item
									{...(element.grid || {})}
									key={'int_' + partData.id + '_' + element.id + '_label'}
								>
									{labelText}
								</Grid>
								<Grid
									key={'int_' + partData.id + '_' + element.id + '_add'}
									item
									lg={element.grid.lg}
									md={element.grid.md}
									sm={element.grid.sm}
									xs={element.grid.xs}
									sx={{
										marginLeft: '16px',
										marginTop: '16px',
										borderColor: errorElements[partData.id]?.[element.id] ? '#F00' : 'rgba(0,0,0,0.5)',
										'&:hover': { borderColor: errorElements[partData.id]?.[element.id] ? '#F00' : '#000' },
										borderRadius: '4px',
										borderWidth: '1px',
										borderStyle: 'solid'
									}}
								>
									<Grid container spacing={2}>
										<FileInput
											onChange={files =>
												!maxFilesLimit && checkFileSize(files)
													? onChange(
															[...(userData?.[partData.id]?.[element.id] || []), ...files],
															partData.id,
															element.id,
															partData?.config,
															element?.config
													  )
													: console.log('Zu Groß oder zu viele Dateien')
											}
											component={
												<Grid
													sx={{
														backgroundColor: '#ccc',
														width: '80px',
														minHeight: '96px',
														padding: '0px!important',
														cursor: 'pointer',
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center'
													}}
													key={'uploadbutton_' + partData.id + '_' + element.id}
													item
													// className="cursor-pointer flex items-center justify-center"
												>
													<FAIcon icon="faFileArrowUp" />
												</Grid>
											}
											title={'Dateiupload'}
											acceptedTypes={acceptedTypes}
											disabled={maxFilesLimit}
										/>

										{userData?.[partData.id]?.[element.id]?.map((file, index) => {
											return (
												<Grid key={'file_' + partData.id + '_' + element.id + '_' + index} item>
													<FilePreview
														file={file}
														hoverIcon={<FAIcon icon="faTrash" />}
														onClick={() =>
															onChange(
																userData?.[partData.id]?.[element.id]?.filter((e, i) => i !== index),
																partData.id,
																element.id
															)
														}
													/>
												</Grid>
											);
										})}
									</Grid>
								</Grid>
								<Grid xs={12} item key={'int_' + partData.id + '_' + element.id + '_counter'}>
									{tooltipText?.[partData.id] !== '' && <div style={{ float: 'left' }}>{tooltipText?.[partData.id]}</div>}
									<div style={{ float: 'right' }}>
										{maxLength ? 'Datei' : 'Anzahl'} {userData?.[partData.id]?.[element.id]?.length || 0} {maxLength ? 'von' : ''}{' '}
										{maxLength}
									</div>
								</Grid>
							</>
						);
					}
					default:
						return '';
				}
			})}
		</>
	);
}

export default FormRenderer;
